"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#4B137B"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "ORANGE_GREEN",
    x1: "-1.11878e-08",
    y1: "5.99999",
    x2: "12.0128",
    y2: "5.99999",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#EEF4D7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.006 14c3.318 0 6.007-2.686 6.007-6s-2.69-6-6.007-6C4.69 2 2 4.686 2 8s2.69 6 6.006 6z",
    clipRule: "evenodd",
    fill: props.gradientVariant && "url(#".concat(props.gradientVariant, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.805 5.047L8.283 8.44h3.029"
  }));
}

var MemoSvgClock = /*#__PURE__*/React.memo(SvgClock);
var _default = MemoSvgClock;
exports["default"] = _default;